import { Injectable } from '@angular/core';

@Injectable()
export class TokenService {
    _token;

    public setToken(token) {
        this._token = token;
    }

    public getToken() {
        return this._token;
    }
}